import React from "react";

import I18n from '../../i18n/Translation';
import {svgIcon} from "../../utils/DomUtils";

const CITA_BASE_URL = "https://www.cita.lu/info_trafic/cameras/images";
const DEFAULT_MOTORWAY = "A1-1";
const MOTORWAYS = {
    'A1-1': {
        name: "A1",
        from: 'luxembourgCitySouth',
        to: 'germanyBorder',
        cams: [46, 70, 81, 84, 86, 100, 101, 103, 110, 112, 119]
    },
    'A1-2': {
        name: "A1",
        from: 'germanyBorder',
        to: 'luxembourgCitySouth',
        cams: [114, 111, 109, 107, 98, 95, 91, 77]
    },
    'A3-1': {
        name: "A3",
        from: 'luxembourgCitySouth',
        to: 'franceBorder',
        cams: [41, 55, 53, 59]
    },
    'A3-2': {
        name: "A3",
        from: 'franceBorder',
        to: 'luxembourgCitySouth',
        cams: [66, 63, 51, 47]
    },
    'A4-1': {
        name: "A4",
        from: 'luxembourgCityHollerich',
        to: 'eschSurAlzette',
        cams: [31, 122, 137, 139]
    },
    'A4-2': {
        name: "A4",
        from: 'eschSurAlzette',
        to: 'luxembourgCityHollerich',
        cams: [140, 133, 125, 120, 36]
    },
    'A6-1': {
        name: "A6",
        from: 'luxembourgCitySouth',
        to: 'belgiumBorder',
        cams: [27, 3]
    },
    'A6-2': {
        name: "A6",
        from: 'belgiumBorder',
        to: 'luxembourgCitySouth',
        cams: [6, 11, 17, 15, 21, 30, 37, 42]
    },
    'A7-1': {
        name: "A7",
        from: 'grunewald',
        to: 'colmarBerg',
        cams: [403, 445, 458, 471]
    },
    'A7-2': {
        name: "A7",
        from: 'colmarBerg',
        to: 'grunewald',
        cams: [466, 455, 444, 402, 400]
    },
    'A13-1': {
        name: "A13",
        from: 'sarrebruck',
        to: 'longwy',
        cams: [269, 237, 235, 231, 218, 161, 139, 154, 143]
    },
    'A13-2': {
        name: "A13",
        from: 'longwy',
        to: 'sarrebruck',
        cams: [145, 147, 151, 140, 162, 164, 200, 204, 217, 230, 236, 268]
    }

};
const CAMERAS = {
    '3': {
        lat: 49.6401499045331,
        lng: 5.88219165802002,
        url: `${CITA_BASE_URL}/cccam_3.jpg`,
        locality: 'Steinfort'
    },
    '6': {
        lat: 49.6366202713283,
        lng: 5.94085693359375,
        url: `${CITA_BASE_URL}/cccam_6.jpg`,
        locality: 'Steinfort'
    },
    '11': {
        lat: 0.0,
        lng: 0.0,
        url: `${CITA_BASE_URL}/cccam_11.jpg`,
        locality: 'Steinfort'
    },
    '15': {lat: 0.0, lng: 0.0, url: `${CITA_BASE_URL}/cccam_15.jpg`, locality: 'Mamer'},
    '17': {
        lat: 49.6389965485953,
        lng: 6.01080894470215,
        url: `${CITA_BASE_URL}/cccam_17.jpg`,
        locality: 'Mamer'
    },
    '21': {
        lat: 49.6229162000762,
        lng: 6.08222544193268,
        url: `${CITA_BASE_URL}/cccam_21.jpg`,
        locality: 'Bridel'
    },
    '27': {
        lat: 49.6050506451143,
        lng: 6.08046054840088,
        url: `${CITA_BASE_URL}/cccam_27.jpg`,
        locality: 'Croix de Cessange'
    },
    '30': {
        lat: 49.5911290484523,
        lng: 6.08290672302246,
        url: `${CITA_BASE_URL}/cccam_30.jpg`,
        locality: 'Bertrange'
    },
    '31': {
        lat: 49.5905587484774,
        lng: 6.08831405639648,
        url: `${CITA_BASE_URL}/cccam_31.jpg`,
        locality: 'Luxembourg'
    },
    '36': {
        lat: 49.600392011776,
        lng: 6.10029816627502,
        url: `${CITA_BASE_URL}/cccam_36.jpg`,
        locality: 'Croix de Cessange'
    },
    '37': {
        lat: 49.5832764053839,
        lng: 6.09100699424744,
        url: `${CITA_BASE_URL}/cccam_37.jpg`,
        locality: 'Croix de Cessange'
    },
    '41': {
        lat: 0.0,
        lng: 0.0,
        url: `${CITA_BASE_URL}/cccam_41.jpg`,
        locality: 'Croix de Gasperich'
    },
    '42': {
        lat: 0.0,
        lng: 0.0,
        url: `${CITA_BASE_URL}/cccam_42.jpg`,
        locality: 'Croix de Cessange'
    },
    '46': {
        lat: 0.0,
        lng: 0.0,
        url: `${CITA_BASE_URL}/cccam_46.jpg`,
        locality: 'Croix de Gasperich'
    },
    '47': {
        lat: 49.5751581286668,
        lng: 6.13346099853516,
        url: `${CITA_BASE_URL}/cccam_47.jpg`,
        locality: 'Croix de Gasperich'
    },
    '51': {
        lat: 49.5451916012645,
        lng: 6.12206429243088,
        url: `${CITA_BASE_URL}/cccam_51.jpg`,
        locality: 'Aire de Berchem'
    },
    '53': {
        lat: 49.5364890954628,
        lng: 6.11391305923462,
        url: `${CITA_BASE_URL}/cccam_53.jpg`,
        locality: 'Aire de Berchem'
    },
    '55': {
        lat: 49.533634336007,
        lng: 6.11324787139893,
        url: `${CITA_BASE_URL}/cccam_55.jpg`,
        locality: 'Croix de Gasperich'
    },
    '59': {
        lat: 49.5289131727974,
        lng: 6.11376285552979,
        url: `${CITA_BASE_URL}/cccam_59.jpg`,
        locality: 'Bettembourg'
    },
    '63': {
        lat: 49.5014406092533,
        lng: 6.11513614654541,
        url: `${CITA_BASE_URL}/cccam_63.jpg`,
        locality: 'Croix de Bettembourg'
    },
    '66': {
        lat: 49.4890227413265,
        lng: 6.11741065979004,
        url: `${CITA_BASE_URL}/cccam_66.jpg`,
        locality: 'France'
    },
    '70': {
        lat: 49.5748241860532,
        lng: 6.13436222076416,
        url: `${CITA_BASE_URL}/cccam_70.jpg`,
        locality: 'Croix de Gasperich'
    },
    '77': {
        lat: 49.5801948192724,
        lng: 6.15406036376953,
        url: `${CITA_BASE_URL}/cccam_77.jpg`,
        locality: 'Sandweiler'
    },
    '81': {
        lat: 0.0,
        lng: 0.0,
        url: `${CITA_BASE_URL}/cccam_81.jpg`,
        locality: 'Tunnel Howald'
    },
    '84': {
        lat: 49.5976105259433,
        lng: 6.17277145385742,
        url: `${CITA_BASE_URL}/cccam_84.jpg`,
        locality: 'Tunnel Howald'
    },
    '86': {
        lat: 49.6168760117652,
        lng: 6.17926239967346,
        url: `${CITA_BASE_URL}/cccam_86.jpg`,
        locality: 'Sandweiler'
    },
    '91': {
        lat: 49.6205304499093,
        lng: 6.1790344119072,
        url: `${CITA_BASE_URL}/cccam_91.jpg`,
        locality: 'Kirchberg'
    },
    '95': {
        lat: 49.6383781718129,
        lng: 6.18475019931793,
        url: `${CITA_BASE_URL}/cccam_95.jpg`,
        locality: 'Jonction Grünewald'
    },
    '98': {
        lat: 49.6415255584211,
        lng: 6.19416475296021,
        url: `${CITA_BASE_URL}/cccam_98.jpg`,
        locality: 'Senningerberg'
    },
    '100': {
        lat: 49.6423870592465,
        lng: 6.20438933372498,
        url: `${CITA_BASE_URL}/cccam_100.jpg`,
        locality: 'Jonction Grünewald'
    },
    '101': {
        lat: 49.6409419524273,
        lng: 6.22759580612183,
        url: `${CITA_BASE_URL}/cccam_101.jpg`,
        locality: 'Senningerberg'
    },
    '103': {
        lat: 49.6410114296981,
        lng: 6.26605868339539,
        url: `${CITA_BASE_URL}/cccam_103.jpg`,
        locality: 'Cargo Center'
    },
    '107': {
        lat: 0.0,
        lng: 0.0,
        url: `${CITA_BASE_URL}/cccam_107.jpg`,
        locality: 'Münsbach'
    },
    '109': {
        lat: 49.6415672442958,
        lng: 6.27085447311401,
        url: `${CITA_BASE_URL}/cccam_109.jpg`,
        locality: 'Münsbach'
    },
    '110': {
        lat: 49.6419563107392,
        lng: 6.27113342285156,
        url: `${CITA_BASE_URL}/cccam_110.jpg`,
        locality: 'Münsbach'
    },
    '111': {
        lat: 49.6617112399965,
        lng: 6.35134220123291,
        url: `${CITA_BASE_URL}/cccam_111.jpg`,
        locality: 'Flaxweiler'
    },
    '112': {
        lat: 49.6749045101864,
        lng: 6.39266967773438,
        url: `${CITA_BASE_URL}/cccam_112.jpg`,
        locality: 'Potaschbierg'
    },
    '114': {
        lat: 49.6813193126217,
        lng: 6.4030122756958,
        url: `${CITA_BASE_URL}/cccam_114.jpg`,
        locality: 'Mertert'
    },
    '119': {
        lat: 49.7299096202412,
        lng: 6.49489402770996,
        url: `${CITA_BASE_URL}/cccam_119.jpg`,
        locality: 'Mertert'
    },
    '120': {
        lat: 49.5810469703395,
        lng: 6.08756303787231,
        url: `${CITA_BASE_URL}/cccam_120.jpg`,
        locality: 'Leudelange'
    },
    '122': {
        lat: 49.5800209090629,
        lng: 6.08813166618347,
        url: `${CITA_BASE_URL}/cccam_122.jpg`,
        locality: 'Croix de Cessange'
    },
    '125': {
        lat: 49.548456381601,
        lng: 6.04509830474854,
        url: `${CITA_BASE_URL}/cccam_125.jpg`,
        locality: 'Pontpierre'
    },
    '133': {
        lat: 49.5313086282265,
        lng: 6.01638793945312,
        url: `${CITA_BASE_URL}/cccam_133.jpg`,
        locality: 'Jonction de Foetz'
    },
    '137': {
        lat: 49.5219768317326,
        lng: 6.00398540496826,
        url: `${CITA_BASE_URL}/cccam_137.jpg`,
        locality: 'Jonction de Foetz'
    },
    '139': {
        lat: 49.5149768154101,
        lng: 5.99200129508972,
        url: `${CITA_BASE_URL}/cccam_139.jpg`,
        locality: 'Esch'
    },
    '140': {
        lat: 49.5125039333481,
        lng: 5.97403049468994,
        url: `${CITA_BASE_URL}/cccam_140.jpg`,
        locality: 'Jonction Lankelz'
    },
    '142': {
        lat: 49.5132005324933,
        lng: 5.97898721694946,
        url: `${CITA_BASE_URL}/cccam_142.jpg`,
        locality: 'Jonction Lankelz'
    },
    '143': {
        lat: 49.5405133267832,
        lng: 5.92175960540771,
        url: `${CITA_BASE_URL}/cccam_143.jpg`,
        locality: 'Sanem'
    },
    '145': {
        lat: 0,
        lng: 0,
        url: `${CITA_BASE_URL}/cccam_145.jpg`,
        locality: 'Differdange'
    },
    '147': {
        lat: 49.5326595019051,
        lng: 5.93130826950073,
        url: `${CITA_BASE_URL}/cccam_147.jpg`,
        locality: 'Differdange'
    },
    '151': {
        lat: 49.5276875455571,
        lng: 5.96561908721924,
        url: `${CITA_BASE_URL}/cccam_151.jpg`,
        locality: 'Tunnel Aessen'
    },
    '154': {
        lat: 0.0,
        lng: 0.0,
        url: `${CITA_BASE_URL}/cccam_154.jpg`,
        locality: 'Jonction Lankelz'
    },
    '161': {
        lat: 49.505067119254,
        lng: 6.04055464267731,
        url: `${CITA_BASE_URL}/cccam_161.jpg`,
        locality: 'Kayl'
    },
    '162': {
        lat: 49.499329375907,
        lng: 6.05515122413635,
        url: `${CITA_BASE_URL}/cccam_162.jpg`,
        locality: 'Kayl'
    },
    '164': {
        lat: 49.4998798382641,
        lng: 6.08904361724854,
        url: `${CITA_BASE_URL}/cccam_164.jpg`,
        locality: 'Dudelange'
    },
    '167': {
        lat: 49.4904165983924,
        lng: 6.11674547195435,
        url: `${CITA_BASE_URL}/cccam_167.jpg`,
        locality: 'Croix de Bettembourg'
    },
    '200': {
        lat: 49.4999913235572,
        lng: 6.12706661224365,
        url: `${CITA_BASE_URL}/cccam_200.jpg`,
        locality: 'Hellange'
    },
    '204': {
        lat: 49.5074811598855,
        lng: 6.18813514709473,
        url: `${CITA_BASE_URL}/cccam_204.jpg`,
        locality: 'Hellange'
    },
    '215': {
        lat: 49.510107556526,
        lng: 6.21590137481689,
        url: `${CITA_BASE_URL}/cccam_215.jpg`,
        locality: 'Altwies'
    },
    '217': {
        lat: 0.0,
        lng: 0.0,
        url: `${CITA_BASE_URL}/cccam_217.jpg`,
        locality: 'Altwies'
    },
    '218': {
        lat: 0.0,
        lng: 0.0,
        url: `${CITA_BASE_URL}/cccam_218.jpg`,
        locality: 'Mondorf'
    },
    '230': {
        lat: 49.5150673692816,
        lng: 6.28632545471191,
        url: `${CITA_BASE_URL}/cccam_230.jpg`,
        locality: 'Altwies'
    },
    '231': {
        lat: 49.5179092825094,
        lng: 6.25628471374512,
        url: `${CITA_BASE_URL}/cccam_231.jpg`,
        locality: 'Mondorf'
    },
    '235': {
        lat: 0.0,
        lng: 0.0,
        url: `${CITA_BASE_URL}/cccam_235.jpg`,
        locality: 'Tunnel Markusbierg'
    },
    '236': {
        lat: 49.4751517014194,
        lng: 6.3585090637207,
        url: `${CITA_BASE_URL}/cccam_236.jpg`,
        locality: 'Mondorf'
    },
    '237': {
        lat: 49.4812861132237,
        lng: 6.33898258209229,
        url: `${CITA_BASE_URL}/cccam_237.jpg`,
        locality: 'Tunnel Markusbierg'
    },
    '268': {
        lat: 49.4763228757454,
        lng: 6.35893821716309,
        url: `${CITA_BASE_URL}/cccam_268.jpg`,
        locality: 'Schengen'
    },
    '269': {
        lat: 49.4774940220656,
        lng: 6.36204957962036,
        url: `${CITA_BASE_URL}/cccam_269.jpg`,
        locality: 'Schengen'
    },
    '400': {
        lat: 49.7066647742669,
        lng: 6.12813949584961,
        url: `${CITA_BASE_URL}/cccam_400.jpg`,
        locality: 'Tunnel Grouft'
    },
    '402': {
        lat: 49.7212608685513,
        lng: 6.10771179199219,
        url: `${CITA_BASE_URL}/cccam_402.jpg`,
        locality: 'Lorentzweiler'
    },
    '403': {
        lat: 49.7168769513543,
        lng: 6.109299659729,
        url: `${CITA_BASE_URL}/cccam_403.jpg`,
        locality: 'Tunnel Gousselerberg'
    },
    '444': {
        lat: 49.7360536671248,
        lng: 6.0982221364975,
        url: `${CITA_BASE_URL}/cccam_444.jpg`,
        locality: 'Tunnel Gousselerberg'
    },
    '445': {
        lat: 49.7447829782765,
        lng: 6.09073340892792,
        url: `${CITA_BASE_URL}/cccam_445.jpg`,
        locality: 'Tunnel Mersch'
    },
    '455': {
        lat: 49.774810486101,
        lng: 6.08552992343903,
        url: `${CITA_BASE_URL}/cccam_455.jpg`,
        locality: 'Tunnel Mersch'
    },
    '458': {
        lat: 49.8144501716126,
        lng: 6.10050201416016,
        url: `${CITA_BASE_URL}/cccam_458.jpg`,
        locality: 'Merscherberg'
    },
    '466': {
        lat: 49.8446247895776,
        lng: 6.10925674438477,
        url: `${CITA_BASE_URL}/cccam_466.jpg`,
        locality: 'Colmarberg'
    },
    '471': {
        lat: 49.8460084948185,
        lng: 6.11397743225098,
        url: `${CITA_BASE_URL}/cccam_471.jpg`,
        locality: 'Colmarberg'
    }
};
const prevIcon = svgIcon('fa-angle-left', 'owl-nav__prev__icon');
const nextIcon = svgIcon('fa-angle-right', 'owl-nav__next__icon');

class TrafficWebcamComponent extends React.Component {

    constructor() {
        super();

        this.state = {
            selectedMotorway: DEFAULT_MOTORWAY,
            selectOptions: this.buildSelectOptions()
        }
    }

    buildSelectOptions() {
        let selectOptions = [];
        for (let m in MOTORWAYS) {
            let motorway = MOTORWAYS[m];
            if (motorway) {
                selectOptions.push({ value: m, name: motorway.name + '[' + I18n.translate("service.commons."+motorway.from) + ' - ' +  I18n.translate("service.commons."+motorway.to) + ']'})
            }
        }
        return selectOptions;
    }

    componentDidMount() {
        $("#owl-traffic-webcam").owlCarousel({
            slideBy: 1,
            dots: false,
            nav: true,
            lazyLoad : true,
            loop: true,
            navText: [prevIcon, nextIcon],
            navClass: ["owl-nav__prev", "owl-nav__next"],
            responsive: {
                0: {
                    items : 1
                },
                500: {
                    items : 2
                },
                770: {
                    items : 3
                },
                980: {
                    items : 4
                }
            }
        });
    }
    getSnapshotBeforeUpdate() {
        $("#owl-traffic-webcam").trigger('destroy.owl.carousel');

        return null;
    }

    componentDidUpdate(){
        $("#owl-traffic-webcam").owlCarousel({
            slideBy: 1,
            dots: false,
            nav: true,
            lazyLoad : true,
            loop: true,
            navText: [prevIcon, nextIcon],
            navClass: ["owl-nav__prev", "owl-nav__next"],
            responsive: {
                0: {
                    items : 1
                },
                500: {
                    items : 2
                },
                770: {
                    items : 3
                },
                980: {
                    items : 4
                }
            }
        });
        window.pymChild && window.pymChild.sendHeight();
    }

    onChangeMotorway = (motorway) => {
        window.logAction();
        this.setState({selectedMotorway: motorway.target.value});
    };

    render() {
        return(
            <div className="traffic-cameras">
                <div className="pure-u-1">
                    <h1 className="service-page__title">
                        { I18n.translate("service.traffic.trafficcamera.title") }
                    </h1>
                    <select onChange={this.onChangeMotorway} value={this.state.selectedMotorway}>
                        {this.state.selectOptions.map((option, i) => {
                            return <option key={i} value={option.value}>{option.name}</option>
                        })}
                    </select>
                    <div id="owl-traffic-webcam" className="pure-u-lg-6-24 pure-u-md-6-24 text-center owl-carousel">
                        {
                            MOTORWAYS[this.state.selectedMotorway].cams.map((cam, i) =>
                                <div key={"cam"+i}>
                                    <img
                                        width="352"
                                        height="288"
                                        alt={CAMERAS[cam].locality}
                                        src={CAMERAS[cam].url}
                                    />
                                     <div className="traffic-page__cameras-title">
                                         {CAMERAS[cam].locality}
                                     </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default TrafficWebcamComponent;





// WEBPACK FOOTER //
// ./js/services/traffic/TrafficWebcamComponent.js